import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import MissionPolicies from '../views/MissionPolicies.vue';
import MeetTheDoctors from '../views/MeetTheDoctors.vue';
import Contact from '../views/Contact.vue';
import Links from '../views/Links.vue';
import errorPage from '../views/404.vue';

Vue.use(VueRouter);

const routes = [
  {
    name: 'Home',
    path: '/',
    component: Home,
  },
  {
    name: 'Mission / Policies',
    path: '/mission-policies',
    component: MissionPolicies,
  },
  {
    name: 'Meet the Drs.',
    path: '/meet-the-drs',
    component: MeetTheDoctors,
  },
  {
    name: 'Contact Us',
    path: '/contact',
    component: Contact,
  },
  {
    name: 'Links',
    path: '/links',
    component: Links,
  },
  {
    name: 'Home',
    path: '/index.html',
    component: Home,
    deprecated: true,
  },
  {
    name: 'Mission / Policies',
    path: '/mission--policies.html',
    component: MissionPolicies,
    deprecated: true,
  },
  {
    name: 'Meet the Drs.',
    path: '/meet-the-drs.html',
    component: MeetTheDoctors,
    deprecated: true,
  },
  {
    name: 'Contact Us',
    path: '/contact-us.html',
    component: Contact,
    deprecated: true,
  },
  {
    name: 'Links',
    path: '/links.html',
    component: Links,
    deprecated: true,
  },
  {
    name: '404',
    path: '*',
    component: errorPage,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export { router as default, routes };
